// parses a date string as a local date without timezone conversion
export const parseLocalDate = (dateString) => {
  if (!dateString) return null;

  try {
    // extract year, month, day from string (works for both YYYY-MM-DD and ISO formats)
    const [year, month, day] = dateString.split(/[-T]/);

    if (year && month && day) {
      // create date in local timezone (month is 0-indexed)
      return new Date(year, month - 1, day);
    }

    return new Date(dateString);
  } catch (error) {
    console.error("error parsing date:", dateString, error);
    return null;
  }
};

// formats a date string for display (timezone-safe)
export const formatLocalDate = (dateString, fallback = "Not set") => {
  if (!dateString) return fallback;

  const localDate = parseLocalDate(dateString);
  if (!localDate) return fallback;

  try {
    return localDate.toLocaleDateString();
  } catch {
    return dateString;
  }
};

// compares a date string to today (timezone-safe), useful for checking if a date is in the past/future
export const compareDateToToday = (dateString) => {
  if (!dateString) return null;

  const date = parseLocalDate(dateString);
  if (!date) return null;

  const today = new Date();

  // set both to midnight for date-only comparison
  date.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  return date - today;
};

// checks if a date string is in the past (timezone-safe)
export const isDateInPast = (dateString) => {
  const comparison = compareDateToToday(dateString);
  return comparison !== null && comparison < 0;
};

// checks if a date string is today (timezone-safe)
export const isDateToday = (dateString) => {
  const comparison = compareDateToToday(dateString);
  return comparison === 0;
};

// checks if a date string is in the future (timezone-safe)
export const isDateInFuture = (dateString) => {
  const comparison = compareDateToToday(dateString);
  return comparison !== null && comparison > 0;
};

// formats a date as YYYY-MM-DD for sending to backend
export const formatDateForBackend = (date) => {
  if (!date) return null;

  try {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  } catch {
    return null;
  }
};

// calculates compact relative time (e.g., "2h ago", "3d ago") - same as RequestCard
export const getTimeAgo = (dateString) => {
  if (!dateString) return "";

  const now = new Date();
  const date = new Date(dateString);
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return "Just now";
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  if (diffDays < 30) return `${Math.floor(diffDays / 7)}w ago`;
  return `${Math.floor(diffDays / 30)}mo ago`;
};
export function formatYmd(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function firstDayOfNextMonthYmd(date) {
  const first = new Date(date.getFullYear(), date.getMonth() + 1, 1);
  return formatYmd(first);
}
